import type { ChoiceTileColumns, ChoiceTileLayout, ChoiceTileVariant } from "./choiceTile.types";

// The columns follow the width of the group itself (a container query), not the viewport: the same group sits in a
// full-width page and in a narrow column next to a summary. A tile needs about 240px for its scene, text and
// indicator. A stacked tile only needs about 180px, as its scene sits above the text, so its columns start earlier.
const GRID_COLUMNS: Record<ChoiceTileVariant, Record<ChoiceTileColumns, string>> = {
  row: {
    2: "@min-[31rem]:grid-cols-2",
    3: "@min-[46rem]:grid-cols-3",
    // A row tile needs about 240px, so four only fit in a wide group.
    4: "@min-[31rem]:grid-cols-2 @min-[61rem]:grid-cols-4",
  },
  // Three stacked tiles go to two columns first, so they do not drop to one column between phone and desktop.
  stacked: {
    2: "@min-[24rem]:grid-cols-2",
    3: "@min-[24rem]:grid-cols-2 @min-[36rem]:grid-cols-3",
    4: "@min-[24rem]:grid-cols-2 @min-[48rem]:grid-cols-4",
  },
};

/** Classes of the element around the tiles of a choice tile group; the group root carries `@container`. */
export function choiceTileLayoutClass(
  layout: ChoiceTileLayout,
  variant: ChoiceTileVariant,
  columns: ChoiceTileColumns,
): string {
  if (layout !== "grid") {
    return "flex flex-col gap-2";
  }
  return `grid grid-cols-1 ${variant === "stacked" ? "gap-3" : "gap-2.5"} ${GRID_COLUMNS[variant][columns]}`;
}
